<template>
	<el-checkbox-group size="mini" @change="changeValue" v-model="ppStatus">
		<el-checkbox-button v-for="item in options" :key="item.value" :label="item.value">{{item.label}}</el-checkbox-button>
	</el-checkbox-group>
</template>
<script>
export default {
    name: 'selectPpStatus',
    props: {
			ppStatus: {
				type: Array,
				default: []
			}
    },
    data() {
			return {
				options: [
					{
						value: 1,
						label: '已匹配',
					},
					{
						value: 6,
						label: '未匹配',
					},
					{
						value: 2,
						label: '部分匹配失败',
					},
          {
						value: 3,
						label: '匹配中',
					},
          {
						value: 4,
						label: '匹配失败',
					}
				],
				value: '',
			}
    },
    methods:{
			changeValue() {
				this.$emit("update:ppStatus", this.ppStatus)
				this.$emit("success", this.ppStatus)
			},
    }
}
</script>

<style>

</style>